export default "__VITE_ASSET__f522e90f__"